import React, { useState } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components/native'
import { SafeAreaView } from 'react-native-safe-area-context'
import I18n from 'APP/I18n'
import StartupActions from 'APP/Redux/StartupRedux'
import LoginActions from 'APP/Redux/LoginRedux'
import Modal from 'APP/Components/Modal'
import LogoHeader from 'APP/Components/LogoHeader'
import { ResponsiveView } from 'APP/Converse/Layout'
import Button from 'APP/Converse/Button'
import Typography from 'APP/Converse/Typography'
import { Images } from 'APP/Themes'

const ScreenContainer = styled(SafeAreaView).attrs({
  edges: ['bottom', 'left', 'right'],
})`
  flex: 1;
`

const ContentContainer = styled(ResponsiveView)`
  gap: ${({ theme }) => theme.metrics.baseMargin * 2}px;
  padding: ${({ theme }) => theme.metrics.baseMargin}px;
  justify-content: space-between;
  flex: 1;
`

const InnerContentContainer = styled(ResponsiveView)`
  gap: ${({ theme }) => theme.metrics.baseMargin * 2}px;
`

const ButtonContainer = styled.View`
  gap: ${({ theme }) => theme.metrics.baseMargin}px;
`

const MandatoryMFAScreen = ({ isMfaLoading, toggleMfa, logout }) => {
  const [showMFAToggleOnModal, setShowMFAToggleOnModal] = useState(false)

  const handleAgreeMFAToggleOnPress = () => {
    toggleMfa()
    closeMFAToggleOnModal()
  }

  const closeMFAToggleOnModal = () => setShowMFAToggleOnModal(false)

  const renderSubtitle = () => {
    const subtitle = I18n.t('MandatoryMFAScreen.subtitle', { returnObjects: true })

    return (
      <Typography>
        <Typography variant="bodyNormal">{subtitle[0]}</Typography>
        <Typography variant="bodyNormalBold">{subtitle[1]}</Typography>
        <Typography variant="bodyNormal">{subtitle[2]}</Typography>
      </Typography>
    )
  }

  return (
    <ScreenContainer>
      <ContentContainer>
        <InnerContentContainer>
          <LogoHeader
            source={Images.logoBlue}
            title={I18n.t('MandatoryMFAScreen.title')}
            subtitle={renderSubtitle()}
          />
          <ButtonContainer>
            <Button
              variant="primary"
              widthVariant="full"
              analyticsName="MandatoryMFAScreen.setupBtn"
              title={I18n.t('MandatoryMFAScreen.setupBtn')}
              isLoading={isMfaLoading}
              onPress={() => setShowMFAToggleOnModal(true)}
              testID="SET_UP_NOW"
            />
          </ButtonContainer>
        </InnerContentContainer>
        <InnerContentContainer>
          <Button
            variant="tertiary"
            widthVariant="full"
            title={I18n.t('MandatoryMFAScreen.signout')}
            onPress={() => logout('Declined MFA challenge')}
            analyticsName="Logout"
            testID={'LOGOUT'}
          />
        </InnerContentContainer>
      </ContentContainer>
      <Modal
        statusBarTranslucent
        visible={showMFAToggleOnModal}
        transparent
        title={I18n.t('MultiFactorAuthentication.confirmModal.title')}
        subtitle={I18n.t('MultiFactorAuthentication.confirmModal.description')}
        primaryActionText={I18n.t('MultiFactorAuthentication.confirmModal.confirm')}
        secondaryActionText={I18n.t('MultiFactorAuthentication.confirmModal.cancel')}
        handleCloseModal={() => closeMFAToggleOnModal()}
        handleSecondaryAction={() => closeMFAToggleOnModal()}
        handlePrimaryAction={() => handleAgreeMFAToggleOnPress()}
        testID="MFA_MODAL"
      />
    </ScreenContainer>
  )
}

const mapStateToProps = (state, props) => {
  const { login } = state
  return {
    ...props.route?.params,
    isMfaLoading: login.toggleMfaRequestRunning,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggleMfa: () => dispatch(StartupActions.mandatoryMfaToggleRequest()),
    logout: (reason) => dispatch(LoginActions.logout(reason, true)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MandatoryMFAScreen)
